import Text from '@ab-core/text';
import styled from 'styled-components';

export const StyledCursive = styled(Text)`
    font-style: italic;
`;
